export default [
  {
    path: '/pa',
    name: 'pa',
    component: () => import('@/views/pa/Index.vue'),
    meta: {
      resource: 'Pa',
      action: 'read',
      pageTitle: 'Parking Compound',
      breadcrumb: [
        {
          text: 'Parking Compound',
          active: true
        }
      ],
    },
  }
]
